import r from "./ghl-ui.es1157.js";
const a = (e) => {
  const {
    opacityDisabled: t,
    heightTiny: o,
    heightSmall: n,
    heightMedium: s,
    heightLarge: g,
    heightHuge: h,
    primaryColor: i,
    fontSize: m
  } = e;
  return {
    fontSize: m,
    textColor: i,
    sizeTiny: o,
    sizeSmall: n,
    sizeMedium: s,
    sizeLarge: g,
    sizeHuge: h,
    color: i,
    opacitySpinning: t
  };
}, l = {
  name: "Spin",
  common: r,
  self: a
}, p = l;
export {
  p as default,
  a as self
};
